import { Component } from 'react'
import s from './DealNameCellRenderer.scss'
import { Link } from 'react-router-dom'

class DealNameCellRenderer extends Component {
  render() {
    const { data, path } = this.props
    if (!data) return null
    const { id, name } = data.deal
    return (
      <Link className={s.link} to={`/${path}/${id}`}>
        {name}
      </Link>
    )
  }
}

export default DealNameCellRenderer
